import {useEffect, useState} from "react";
import axios from "axios";
import {buyeeUrl} from "utils/url";
import {dateFormat} from "utils/date";

const Notices = () => {
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    axios
      .get('files/cobrand/public_messages.json')
      .then(response => {
        setNotices(response.data);
      });
  }, []);

  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      {notices.length > 0 &&
        <div className="width-contents tw-notice">
          <section className={'tw-notice__block ' + (isOpened ? 'tw-notice__block--opened' : 'tw-notice__block--closed')}>
            <h2 className={'notice-heading ' + (isOpened ? 'notice-heading--opened' : 'notice-heading--closed')} onClick={() => setIsOpened(!isOpened)}>
              <p>購買須知</p>
            </h2>
            <div className="tw-notice__contents">
              <ul className="notice-list">
                {notices.map((notice, i) =>
                  <li key={i}>
                    <span>{dateFormat(notice.publishedFrom)}</span>{notice.title}
                  </li>
                )}
              </ul>
              <p className="notice-link txt__link--arrow">
                <a className="txt__link" href={buyeeUrl("information/public/list?lang=cht&rc=twy_cobrand_entry&twTran=1")} target="_blank">
                  通知列表
                </a>
              </p>
            </div>
          </section>
        </div>
      }
    </>
  );
};

export default Notices;
